import Api from './Api';

const END_POINT = 'supplier-accounts';

export default {

    async get_all(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request);
    },

    amortize(payment) {
        return Api.post(`${END_POINT}/amortize`, payment);
    },

}